<script module lang="ts">
  export type FilterChip = {
    id: string;
    label: string;
    /** Rendered as the chip's count pill — omit rather than passing 0 if the
        number isn't meaningful for that chip. */
    count?: number;
  };
</script>

<script lang="ts">
  // A row of chips that never wraps on a phone. Two jobs, same shape: pick a
  // filter (pass `value`, get an active chip back) or jump to a section (omit
  // `value`, nothing is ever active). Below `sm` the row scrolls sideways,
  // bleeding past the page gutter so the last chip is visibly cut off rather
  // than looking like the end of the list; at `sm` and up it just wraps,
  // because the width is there.
  const {
    chips,
    value,
    onSelect,
    ariaLabel,
    sticky = false,
    class: className = ''
  }: {
    chips: FilterChip[];
    /** The selected chip id. Omitted for a pure navigation rail. */
    value?: string;
    onSelect: (id: string) => void;
    ariaLabel: string;
    /** Pin the row under the page header on phones — for long record pages
        where the anchors are the only way back to the top-level structure. */
    sticky?: boolean;
    /** Layout classes (margins, breakpoint visibility) land on the row
        itself: a wrapper element would become the sticky row's containing
        block, and a sticky element can never outlive a parent exactly its
        own height — it would unstick the moment it scrolled. */
    class?: string;
  } = $props();
</script>

<nav class="tym-chiprow {sticky ? 'tym-chiprow-sticky' : ''} {className}" aria-label={ariaLabel}>
  {#each chips as chip (chip.id)}
    <button
      type="button"
      class="tym-chip {value === chip.id ? 'active' : ''}"
      aria-current={value === chip.id ? 'true' : undefined}
      onclick={() => onSelect(chip.id)}
    >
      {chip.label}
      {#if chip.count != null}<span class="tym-chip-count">{chip.count}</span>{/if}
    </button>
  {/each}
</nav>
